import React, { useState, useEffect } from "react";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import SideBar from "../../Components/Navbar/Sidebar";
import Head from "../../Components/ontabletop/head";
import Loader from "../../Components/loader";
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { fetchBlogs, gohBlogUpdateStatus } from "../../Components/Apis/apis";

const Allblog = () => {
  const headers = [
    { key: "id", label: "Id" },
    { key: "image", label: "Image" },
    { key: "title", label: "title" },
    { key: "for", label: "Blog for" },
    { key: "category", label: "Category" },
    { key: "CreatedOn", label: "Created on" },
    { key: "created_by", label: "Created by" },
    { key: "", label: "Active" },
    { key: "", label: "Edit" },
  ];
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");

  const fetchPost = async () => {
    setLoading(true);
    const data = await fetchBlogs();
    setLoading(false);
    if(data.success === true){
      toast(data.message);
      setFilterData(data.result);
      setTotal(data.result.length);
    } else {
      toast.error(data.message);
      setFilterData([]);
      setTotal(0);
    }
  };

  useEffect(() => {
    fetchPost();
  }, []);

  const formatDate = (dateTimeString) => {
    const options = { 
      day: "2-digit", 
      month: "2-digit", 
      year: "2-digit",
      hour12: true,
    };
    const formattedDateTime = new Date(dateTimeString).toLocaleString("en-US", options);
    return formattedDateTime;
  };

  const updateStatus = async (id, status) => {
    const data = await gohBlogUpdateStatus(id, status);
    if (data.success === true) {
      fetchPost(); 
      toast(data.message);
    } else {
      toast.error(data.message);
    }
  };

  const handleCheckboxChange = (e, id, currentStatus) => {
    const newValue = e.target.checked ? 1 : 0;
    if (newValue !== currentStatus) {
      updateStatus(id, newValue);
    }
  };

  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages">
          <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
          {loading ? (
            <Loader />
          ) : (
            <>
              {filterData.length === 0 ? (
                <h2 className="text-secondary">No blog found</h2>
              ) : (
                <>
                  <table className="table table-boarder table-hover table-striped table-sm">
                    <thead className="thead-dark">
                      <tr>
                        {headers.map(({ key, label }) => (
                          <th key={key}>{label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filterData
                        .filter((obj) => (
                          query === "" ||
                          obj.title.toLowerCase().includes(query.toLowerCase()) ||
                          obj.for.toLowerCase().includes(query.toLowerCase()) ||
                          obj.created_by.toLowerCase().includes(query.toLowerCase())
                        ))
                        .slice((page - 1) * postPerpage, page * postPerpage)
                        .map((posts, index) => (
                          <tr key={index}>
                            <td>{posts.id}</td>
                            <td><img src={posts.image} alt={posts.title} style={{height:"80px",width:"120px"}} /></td>
                            <td className="w-25">{posts.title}</td>
                            <td>{posts.for}</td>
                            <td>{posts.category}</td>
                            <td>{formatDate(posts.CreatedOn)}</td>
                            <td>{posts.created_by}</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={posts.active === 1}
                                onChange={(e) => handleCheckboxChange(e, posts.id, posts.active)}
                              />
                            </td>
                            <td>
                              <Link to={`/editblog/${posts.id}`} className="btn btn-info text-light">Edit</Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <Pajination
                    setPostPerPage={setPostPerPage}
                    postPerpage={postPerpage}
                    page={page}
                    setPage={setPage}
                    total={total}
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
      <ToastContainer/>
    </>
  );
};

export default Allblog;
